import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { default as DateSelect, registerLocale } from 'react-datepicker';
import InputMask from 'react-input-mask';

import 'react-datepicker/dist/react-datepicker.css';

import ptBr from 'date-fns/locale/pt-BR';

registerLocale('pt-BR', ptBr)

class DatePicker extends Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    mask: PropTypes.string,
    maskChar: PropTypes.string
  }

  static defaultProps = {
    value: null,
    mask: "99/99/9999",
    maskChar: "_"
  }

  render() {
    const { value, mask, maskChar, ...props } = this.props;

    return (
      <DateSelect
        locale="pt-BR"
        customInput={
          <InputMask value={value} mask={mask} maskChar={maskChar} />
        }
        {...props} />
    );
  }
}

export default DatePicker;
